import BemIt, { addClass } from "@gtechdoodler/bem-it";
import StyledTypography from "./Typography.styles";
import useViewport from "../../../hooks/useViewport";
import { TypographyProps, TypographyVariants } from "./Typography.types";

const variantTagMapping: TypographyVariants = {
	h1: "h1",
	h2: "h2",
	h3: "h3",
	h4: "h4",
	h5: "h5",
	h6: "h6",
	body: "span",
	"body-large": "span",
	"body-small": "span",
	caption: "span",
};

const Typography: React.FC<TypographyProps> = ({
	className,
	display = "inline-block",
	htmlTag,
	variant = "body",
	...props
}) => {
	const block = new BemIt("Typography");
	const vp = useViewport();

	return (
		<>
			{props.children && (
				<StyledTypography
					forwardedAs={htmlTag || variantTagMapping[variant]}
					className={addClass(className).after(block.mod(variant))}
					display={display}
					variant={variant}
					viewport={vp}
					{...props}
				/>
			)}
		</>
	);
};

export default Typography;
